module.exports = __webpack_public_path__ + "static/media/terms-and-conditions.79749940.jpg";